import { render, staticRenderFns } from "./BuildingManagement.vue?vue&type=template&id=4e7047e6&scoped=true&"
import script from "./BuildingManagement.vue?vue&type=script&lang=js&"
export * from "./BuildingManagement.vue?vue&type=script&lang=js&"
import style0 from "./BuildingManagement.vue?vue&type=style&index=0&id=4e7047e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7047e6",
  null
  
)

export default component.exports